// TODO: rewrite this as a module which only export submitForm() when reqwest
// is imported
export default {
    name: 'formSubmitService',
    dependencies: ['xhrservice', 'reqwest'],
    callable(xhr, reqwest) {
        function submitForm(form) {
            const method = getFormMethod(form);
            const options = {
                method,
                url: rewriteToJsonUrl(form.action),
                type: 'json',
                headers: {
                    'x-csrf-token': document.querySelector(
                        "meta[name='csrf-token']"
                    ).content,
                },
            };

            if (method === 'POST') {
                options.data = reqwest.serialize(form); // TODO: FormData
            }

            return xhr.request(options).catch(error => {
                // If we get a 5xx error, try once more.
                if (String(error.status)[0] === '5') {
                    return xhr.request(options);
                }
                throw error;
            });
        }

        function getFormMethod(form) {
            // Browsers only support GET and POST for <form>. For other methods, we can use
            // Spring's HiddenHttpMethodFilter and an input with the name `_method`.
            const methodOverrideInput = form.elements._method;
            return (methodOverrideInput
                ? methodOverrideInput.value
                : form.method
            ).toUpperCase();
        }

        function rewriteToJsonUrl(url) {
            return url.replace(/\.html$/, '.json');
        }

        return submitForm;
    },
};



// WEBPACK FOOTER //
// ./services/formSubmitService.js